import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { AllZonesResponseModel, PlantIdRequest, ZoneDropDownDto, ZoneDropDownResponseModel, ZoneResponseModel,AllRacksResponseModel, RmZonesResponseModel, RmZonesDropDownResponseModel } from '@gtpl/shared-models/masters';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Raw, Repository ,getManager, Not} from 'typeorm';
import { PlantRequest } from './dto/plant.request';
import { RackByIdDto } from './dto/rack-id-request-dto';

import appSettings from 'apps/services/config';
import { CommonResponse } from '@gtpl/shared-models/production-management';
import { ZoneAdapter } from '../zone-master/dto/zone.adapter';
import { ZoneRequest } from '../zone-master/dto/zone.request';
import { RmZonesDTO } from './dto/rm-zone.dto';
import { RmZones } from './rm-zones.entity';
import { RmZoneAdapter } from './dto/rm-zone.adapter';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';


@Injectable()
export class RmZonesService {
    constructor(
      private logService:LogsService,

        @InjectRepository(RmZones)
        private zoneRepository: Repository<RmZones>,
        private zoneAdapter: RmZoneAdapter,
      ) {}
      /**
       * create or update Zone
       * @param RmzonesDTO 
       * @param isUpdate 
       * @param request 
       */
      async createZone(rmzonesDTO: RmZonesDTO, isUpdate: boolean,request:Request): Promise<RmZonesResponseModel> {
        try {
            // to check whether Zone exists with the passed  Zone  or not. if isUpdate is false, a check will be done whether a record with the passed Zone is existing or not. if a record exists then a return message wil be send with out saving the data.  if record is not existing with the passed Zone  then a new record will be created. if isUpdate is true, then no check will be performed and  record will be updated(if record exists with the passed cluster code) or created.
            if (!isUpdate) {
            const ZoneEntity = await this.getZoneDetailsWithoutRelations(rmzonesDTO.rmZoneCode);
            if (ZoneEntity) {
                throw new ZoneResponseModel(false,11104, 'Zone already exists');         
            }         
            }
            else{
                const ZoneEntity = await this.getZoneDetailsWithoutRelations(rmzonesDTO.rmZoneCode);
                if(ZoneEntity){
                    if(ZoneEntity.rmZoneId!=rmzonesDTO.rmZoneId) {
                        throw new ZoneResponseModel(false,11104, 'Zone already exists');      
                    }
                }
              }
            const convertedZoneEntity: RmZones = this.zoneAdapter.convertDtoToEntity(rmzonesDTO,isUpdate);

            console.log(convertedZoneEntity);
            const savedZoneEntity: RmZones = await this.zoneRepository.save(
            convertedZoneEntity
            );
            console.log(savedZoneEntity);

            const savedZoneDto: RmZonesDTO = this.zoneAdapter.convertEntityToDto(savedZoneEntity);
            if (savedZoneDto) {
            // generating resposnse
            const response = new RmZonesResponseModel(true,isUpdate ? 11101 : 11100,isUpdate? 'Zone Updated Successfully': 'Zone Created Successfully',savedZoneDto);
            const name=isUpdate?'updated':'created'
            const newLogDto = new LogsDto(1,name, 'RmZones', savedZoneDto.rmZoneId, true, '',savedZoneDto.createdUser)
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
            return response;
            } else {
            throw new RmZonesResponseModel(false,11106,'Zone saved but issue while transforming into DTO');
            }
        } catch (error) {
            // when error occures while saving the data , the execution will come to catch block.
            // tslint:disable-next-line: typedef
            return error;
        }
    }
    /**
     * get Zone details
     * @param rmZoneCode 
     */
    // @LogActions({isAsync: true})
    async getZoneDetailsWithoutRelations(rmZoneCode: string): Promise<RmZones> {
        // tslint:disable-next-line: typedef
        const ZoneResponse = await this.zoneRepository.findOne({
        where: {rmZoneCode: Raw(alias => `rm_zone_code = '${rmZoneCode}'`)},
        });
        console.log(ZoneResponse);
        if (ZoneResponse) {
        return ZoneResponse;
        } else {
        return null;
        }
    }
    async getAllZoneDropDown(): Promise<ZoneDropDownResponseModel> {
    try {
        const zoneDTO: ZoneDropDownDto[] = [];
        const zoneEntities: RmZones[] = await this.zoneRepository.find({ select: ['rmZoneId', 'rmZoneName'], where: { isActive: true }, order: {rmZoneName:"ASC"}})


        if (zoneEntities && zoneEntities.length > 0) {
            zoneEntities.forEach(zoneEntity => {
                zoneDTO.push(new ZoneDropDownDto(zoneEntity.rmZoneId, zoneEntity.rmZoneName));
            });
            const response = new ZoneDropDownResponseModel(true, 11108, "zone retrieved successfully", zoneDTO);
            const newLogDto = new LogsDto(1,'view', 'RmZones', 0, true, '','')
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
            return response;
        } else {
            throw new ZoneResponseModel(false,99998, 'Data not found');
        }
    } catch (err) {
        throw err;
    }
}
async getPlantWiseZones(req: PlantIdRequest):Promise<RmZonesDropDownResponseModel>{
    console.log(req)
    try{
        const manager = getManager();
        let query = `select rm_zone_id as zoneId,rm_zone_code as zoneName from `+appSettings.masters_db+`.rm_zones where  is_active = true`;
        if(req.unitcodeId ===  1){
            query = query + " and plant_id ="+req.unitcodeId
        }
        if(req.unitcodeId !=  1){
            query = query + " and plant_id != 1 OR plant_id Is null"
        }
        const data = await manager.query(query)
        if(data.length > 0 ){
            return new RmZonesDropDownResponseModel(true,1010,"Data retreived sucessfulyy",data);
        }else{
            return new RmZonesDropDownResponseModel(false,1010,"Data not found");
        }
    }catch (err) {
        throw err;
    }
}
async getrmZoneDetails():Promise<CommonResponse>{
    try{
        const manager=getManager()
        let query3 =  `select  rz.rm_zone_code as rmZoneCode, rz.rm_zone_name as rmZoneName,  rz.plant_id as plantId,
        uc.unit_name  as unitName, uc.unit_code_id as unitCodeId
       from ${appSettings.masters_db}.rm_zones rz
       left join ${appSettings.masters_db}.unitcodes uc on uc.unit_code_id = rz.plant_id `
       const result2 =await manager.query(query3)
       if(result2.length>0){
        return new CommonResponse(true, 1,'Data retrieved successfully', result2)
       }
       else{
        return new CommonResponse(false, 0,'No data found',[])
       }
       
       }catch(err){
        throw(err)
       }
    }


}
